
import React, { useEffect, useRef, useMemo } from 'react';
import { createPortal } from 'react-dom';
import './Modal.css';

const Modal = ({ 
  title, 
  children, 
  onClose, 
  showModal = true,
  customContent = false // Per modali personalizzati senza header/footer
}) => {
  const scrollPositionRef = useRef(0);
  const bodyRef = useRef(document.body);
  const modalPositionRef = useRef({ top: 0, left: 0 });

  useEffect(() => {
    if (showModal) {
      // Salva la posizione di scroll corrente
      scrollPositionRef.current = window.scrollY;
    }

    return () => {
      // Non fare nulla nel cleanup per mantenere la posizione
    };
  }, [showModal]);

  if (!showModal) return null;

  const modalContent = customContent ? (
    children
  ) : (
    <div className="modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h3 className="modal-title">{title}</h3>
      </div>
      <div className="modal-content">
        {children}
      </div>
      <div className="modal-footer">
        <button onClick={onClose} className="modal-close-button">
          Chiudi
        </button>
      </div>
    </div>
  );

  return createPortal(
    <div 
      className="modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className={`modal-content-wrapper ${customContent ? 'custom' : 'standard'}`}>
        {modalContent}
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};


export default Modal;
